"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGIN_TYPE = void 0;
var react_1 = __importDefault(require("react"));
var reconnect_js_1 = require("reconnect.js");
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var User = __importStar(require("../../Actions/User"));
var Google_1 = require("@styled-icons/boxicons-logos/Google");
var FacebookCircle_1 = require("@styled-icons/boxicons-logos/FacebookCircle");
var Line_1 = require("@styled-icons/fa-brands/Line");
var LOGIN_TYPE;
(function (LOGIN_TYPE) {
    LOGIN_TYPE["GOOGLE"] = "GOOGLE";
    LOGIN_TYPE["FACEBOOK"] = "FACEBOOK";
    LOGIN_TYPE["LINE"] = "LINE";
    LOGIN_TYPE["NORMAL"] = "NORMAL";
})(LOGIN_TYPE || (LOGIN_TYPE = {}));
exports.LOGIN_TYPE = LOGIN_TYPE;
function LoginForm(props) {
    var _this = this;
    var actions = reconnect_js_1.useOutlet('actions')[0];
    var admin = props.admin, _a = props.formTitle, formTitle = _a === void 0 ? '' : _a, _b = props.adminFormTitle, adminFormTitle = _b === void 0 ? '' : _b, _c = props.canNormalLogin, canNormalLogin = _c === void 0 ? true : _c, _d = props.canFacebookLogin, canFacebookLogin = _d === void 0 ? true : _d, _e = props.canGoogleLogin, canGoogleLogin = _e === void 0 ? true : _e, _f = props.canLineLogin, canLineLogin = _f === void 0 ? true : _f, _g = props.onSucceed, onSucceed = _g === void 0 ? function () { return 0; } : _g, _h = props.onBeforeLoginClick, onBeforeLoginClick = _h === void 0 ? function () { return true; } : _h, _j = props.renderExtra, renderExtra = _j === void 0 ? null : _j;
    var onSocialProviderLogin = function (type) { return __awaiter(_this, void 0, void 0, function () {
        var result, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, onBeforeLoginClick(type, {})];
                case 1:
                    result = _a.sent();
                    if (!result) {
                        return [2 /*return*/];
                    }
                    switch (type) {
                        case LOGIN_TYPE.GOOGLE:
                            User.googleRedirect();
                            break;
                        case LOGIN_TYPE.FACEBOOK:
                            User.facebookRedirect();
                            break;
                        case LOGIN_TYPE.LINE:
                            User.lineRedirect();
                            break;
                        default:
                            break;
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    console.warn('login form error:', err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onFinish = function (values) { return __awaiter(_this, void 0, void 0, function () {
        var username, password, _next, ex_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    username = values.username, password = values.password;
                    return [4 /*yield*/, actions.setLoading(true)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 6, 7, 9]);
                    return [4 /*yield*/, onBeforeLoginClick(LOGIN_TYPE.NORMAL, {
                            data: { username: username, password: password },
                            admin: admin,
                        }, onSucceed)];
                case 3:
                    _next = _a.sent();
                    if (!_next) return [3 /*break*/, 5];
                    return [4 /*yield*/, User.login({ username: username, password: password }, admin)];
                case 4:
                    _a.sent();
                    onSucceed();
                    _a.label = 5;
                case 5: return [3 /*break*/, 9];
                case 6:
                    ex_1 = _a.sent();
                    console.log('EX', ex_1);
                    antd_1.message.error('登入失敗，請重新嘗試');
                    return [3 /*break*/, 9];
                case 7: return [4 /*yield*/, actions.setLoading(false)];
                case 8:
                    _a.sent();
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var onFinishFailed = function (errorInfo) {
        console.log('Failed:', errorInfo);
    };
    var title = react_1.default.useMemo(function () {
        var ele = null;
        if (admin) {
            if (!adminFormTitle || typeof adminFormTitle === 'string') {
                ele = react_1.default.createElement("h2", null, adminFormTitle || 'ADMIN 登入');
            }
            else {
                ele = adminFormTitle;
            }
        }
        else {
            if (!formTitle || typeof formTitle === 'string') {
                ele = react_1.default.createElement("h2", null, formTitle || '登入');
            }
            else {
                ele = formTitle;
            }
        }
        return ele;
    }, [admin, adminFormTitle, formTitle]);
    var form = (react_1.default.createElement(antd_1.Form, { name: "basic", onFinish: onFinish, onFinishFailed: onFinishFailed },
        react_1.default.createElement(antd_1.Form.Item, { name: "username", rules: [
                {
                    required: true,
                    message: '請輸入帳號!',
                },
            ], style: { marginBottom: 10 } },
            react_1.default.createElement(antd_1.Input, { className: "input-style", placeholder: "\uFF0A\u5E33\u865F" })),
        react_1.default.createElement(antd_1.Form.Item, { name: "password", rules: [
                {
                    required: true,
                    message: '請輸入密碼!',
                },
            ], style: { marginBottom: 26 } },
            react_1.default.createElement(antd_1.Input.Password, { className: "input-style", placeholder: "\uFF0A\u5BC6\u78BC" })),
        react_1.default.createElement(antd_1.Form.Item, { style: { marginBottom: 26 } },
            react_1.default.createElement(antd_1.Button, { className: "button-style", type: "primary", htmlType: "submit" }, "\u767B\u5165"))));
    return (react_1.default.createElement(Wrapper, null,
        title,
        !admin && canNormalLogin && form,
        admin && form,
        !admin && (canFacebookLogin || canGoogleLogin || canLineLogin) && (react_1.default.createElement(SocialSignin, null,
            canNormalLogin && react_1.default.createElement("p", { className: "text" }, "\u6216\u4F7F\u7528\u4EE5\u4E0B\u65B9\u6CD5\u767B\u5165"),
            react_1.default.createElement("div", { className: "content" },
                canGoogleLogin && (react_1.default.createElement(GoogleBtn, { onClick: function () { return onSocialProviderLogin(LOGIN_TYPE.GOOGLE); } })),
                canFacebookLogin && (react_1.default.createElement(FacebookBtn, { onClick: function () { return onSocialProviderLogin(LOGIN_TYPE.FACEBOOK); } })),
                canLineLogin && (react_1.default.createElement(LineBtn, { onClick: function () { return onSocialProviderLogin(LOGIN_TYPE.LINE); } }))))),
        renderExtra && renderExtra(__assign({}, props))));
}
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & > h2 {\n    margin-bottom: 20px;\n    font-size: 25px;\n    color: #000000;\n    letter-spacing: 3px;\n    line-height: 25px;\n    text-align: center;\n  }\n\n  & .input-style {\n    border: 1px solid #e5e5ea;\n    border-radius: 5px;\n    padding: 10px 15px;\n    height: 45px;\n  }\n\n  & .button-style {\n    box-shadow: 0 5px 8px 0 lightgray;\n    border-radius: 10px;\n    padding: 9px;\n    width: 100%;\n    height: 40px;\n    font-weight: 500;\n    font-size: 15px;\n  }\n"], ["\n  & > h2 {\n    margin-bottom: 20px;\n    font-size: 25px;\n    color: #000000;\n    letter-spacing: 3px;\n    line-height: 25px;\n    text-align: center;\n  }\n\n  & .input-style {\n    border: 1px solid #e5e5ea;\n    border-radius: 5px;\n    padding: 10px 15px;\n    height: 45px;\n  }\n\n  & .button-style {\n    box-shadow: 0 5px 8px 0 lightgray;\n    border-radius: 10px;\n    padding: 9px;\n    width: 100%;\n    height: 40px;\n    font-weight: 500;\n    font-size: 15px;\n  }\n"])));
var SocialSignin = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 15px;\n  padding: 10px;\n\n  & > .text {\n    margin-bottom: 15px;\n    font-size: 13px;\n    letter-spacing: 0.93px;\n    text-align: center;\n    line-height: 15px;\n  }\n\n  & > .content {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: stretch;\n  }\n"], ["\n  margin-bottom: 15px;\n  padding: 10px;\n\n  & > .text {\n    margin-bottom: 15px;\n    font-size: 13px;\n    letter-spacing: 0.93px;\n    text-align: center;\n    line-height: 15px;\n  }\n\n  & > .content {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: stretch;\n  }\n"])));
var GoogleBtn = styled_components_1.default(Google_1.Google).attrs({
    size: 40,
    color: '#ea4335',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0px 10px;\n  cursor: pointer;\n"], ["\n  margin: 0px 10px;\n  cursor: pointer;\n"])));
var FacebookBtn = styled_components_1.default(FacebookCircle_1.FacebookCircle).attrs({
    size: 40,
    color: '#1877f2',
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin: 0px 10px;\n  cursor: pointer;\n"], ["\n  margin: 0px 10px;\n  cursor: pointer;\n"])));
var LineBtn = styled_components_1.default(Line_1.Line).attrs({
    size: 40,
    color: '#02C755',
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin: 0px 10px;\n  cursor: pointer;\n"], ["\n  margin: 0px 10px;\n  cursor: pointer;\n"])));
exports.default = LoginForm;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
